import * as React from 'react';
import * as styles from './slonoTopTitle.css';
import { TopTitle } from '../../TopOfferCard/TopTitle';
import { IOffer } from '../../types/offer';

interface ISlonoTopTitle {
  offer?: IOffer;

  handleTitleClick(e: React.MouseEvent<HTMLAnchorElement>): void;
}

export const SlonoTopTitle = (props: ISlonoTopTitle) => {

  const { handleTitleClick, offer} = props;

  return (
    <a onClick={ handleTitleClick }
       href={ offer && offer.fullUrl }
       className={ styles['header'] }
       target="_blank"
    >
      <TopTitle/>
    </a>
  );
};
